import {createAsyncThunk} from '@reduxjs/toolkit';
import {AppDispatch, RootState} from '../../store';
import Logger from 'src/logging/Logger';
import AppApi from 'src/api/AppApi';
import Events from 'src/logging/Events';
import {generateErrorMessage} from 'src/logging/generateErrorMessage';
import CrashlyticsEvents from 'src/logging/Crashlytics';

export type DeleteNotificationMessageParams = {
  locationId: string;
  externalServiceId: string;
  messageType: string;
};
export const messageDelete = createAsyncThunk<
  boolean | undefined,
  DeleteNotificationMessageParams,
  {dispatch: AppDispatch; state: RootState}
>(
  'message/delete',
  async (
    {locationId, externalServiceId, messageType},
    {getState},
  ) => {
    const accountId = getState().account.account.id;
    try {
      await AppApi.deleteMessage(accountId, externalServiceId, messageType);
      Logger.Log.LogAPIEvent(
        'PlatformAPI',
        'NotificationDeleteMessageParams',
        JSON.stringify({
          locationId: locationId,
          extServiceId: externalServiceId,
          accountId,
        }),
        '',
      );
      return true;
    } catch (err) {
      CrashlyticsEvents.log(
        'Exception',
        'notification-delete-message',
        generateErrorMessage(err),
      );
      Events.Error.trackEvent(
        'Exception',
        'notification-delete-message',
        generateErrorMessage(err),
      );
      return false;
    }
  },
);
